"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardBadgeMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _alphaMixin = require("../alphaMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
/** @class PropertyCardBadgeMixin */
/** @method */
var PropertyCardBadgeMixin = function PropertyCardBadgeMixin(props) {
  var appearance = props.appearance;
  return (0, _styledToken.default)({
    backgroundColor: "PropertyCard.badge.backgroundColor." + appearance,
    borderRadius: 'PropertyCard.badge.borderRadius',
    fontColor: "PropertyCard.badge.fontColor." + appearance,
    fontType: 'PropertyCard.badge.fontType',
    horizontalPadding: "PropertyCard.badge.horizontalPadding",
    opacity: "PropertyCard.badge.opacity." + appearance,
    verticalPadding: "PropertyCard.badge.verticalPadding"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      horizontalPadding = _ref.horizontalPadding,
      opacity = _ref.opacity,
      verticalPadding = _ref.verticalPadding;
    return (0, _styledComponents.css)(["background-color:", ";border-radius:", ";color:", ";display:inline-block;padding:", "px ", "px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", " ", ""], (0, _alphaMixin.alphaMixin)(backgroundColor, opacity)(props), borderRadius, fontColor, verticalPadding, horizontalPadding, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType,
      fontColor: fontColor
    }, props)), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.PropertyCardBadgeMixin = PropertyCardBadgeMixin;